import styled from "styled-components";

export const RightBalckStyled = styled.div`
  width: 342px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(53, 58, 80, 0.3);
  z-index: 1;
  opacity: 0.5s;

`;
